import React, { useEffect } from "react";
import TTHeader from "../components/TTHeader";
import { TTRoutes } from "../routes/routes";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails, receiveProfileData, reset } from "../redux/profile/profileSlice";
import { GetLocalStore, LocalStore, RemoveTreatTeamLocalStore } from "../utils/storage";
import { ServiceApi } from "../services/index.service";
import axios from "axios";

const TTLayout = ({ userType }) => {
  const navigate = useNavigate();
  const dispatch=useDispatch()
  const service = new ServiceApi();

  const basepath = (userType === 'DMB') ? 'dmb' : 'treatteam';

  const profile = useSelector((state) => state.profile);
  useEffect(() => {
    if (!profile) {
      if(GetLocalStore("lognDetails")){
        const lognDetails=GetLocalStore("lognDetails")
        handleLogin(lognDetails)
      }else{
        navigate(`/${basepath}/login`);
      }
    }
  }, [profile]);

  const handleLogin = async (lognDetails) => {
    const req = {
      UserName: lognDetails?.UserName,
      Password: lognDetails?.Password,
    };
    const res = await service.SignInUser(req);
    console.log(res)
    if (res?.statusCode === 200) {
      const obj = {
        ...res?.data?.user_roles,
        permissions: res?.data.permissions,
        token:res?.token
      };
      dispatch(receiveProfileData(obj));
      dispatch(getUserDetails({ preferred_username: obj?.user_name }))
      LocalStore("userDetails", obj);
    } else {
      navigate(`/${basepath}/login`);
    }
  };

  axios.interceptors.request.use(
    (config) => {
      // Modify the request configuration or add headers
      if(!config.url?.includes("signin")){
        config.headers['Authorization'] = GetLocalStore('userDetails')?.token;
      }
      return config;
    },
    (error) => {
      // Handle request errors
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    response => response,
    error => {
      const {status} = error.response;
      const requestUrl = error.config?.url || '';
      const isPLToolEndpoint = requestUrl.includes('plsaveperiod') || requestUrl.includes('plupdatestatus') || requestUrl.includes('plbootstrap') || requestUrl.includes('plcustomschema') || requestUrl.includes('plreopenrequest');
      if ((status === 403 || status === 401) && !isPLToolEndpoint) {
        // alert('Unauthorized')
        // generateParams()
        dispatch(reset())
        RemoveTreatTeamLocalStore()
        // navigate("/treatteam/login");
      }
      return Promise.reject(error);
   }
  )

  const filteredTTRoutes = (userType === "DMB") ? TTRoutes.filter(r => (r.name === 'TTDashboard') || (r.name === 'BoardAdministration') || (r.name === 'Login')) : TTRoutes;

  // console.log('filteredTTRoutes ', filteredTTRoutes);

  return (
    <div className="min-h-full bg-neutral-light relative">
      <TTHeader userType={userType} />
      <Routes>
        {[...filteredTTRoutes].map((route) => {
          return route.component ? (
            <Route
              path={route?.path}
              element={route?.component}
              key={route?.key}
            />
          ) : (
            <></>
          );
        })}
      </Routes>
    </div>
  );
};

export default TTLayout;
